import { useFeatureFlagEnabled } from 'posthog-js/react';

export const INSTANT_REFLEX_REVIEWER_FLAG = 'instant_reflex_reviewer';

const POSTHOG_ENABLED = import.meta.env.REACT_APP_POSTHOG_ENABLED === 'true';

export default function useIsInstantReflexSpecialist(): boolean {
  const isEnabled = useFeatureFlagEnabled(INSTANT_REFLEX_REVIEWER_FLAG);

  return POSTHOG_ENABLED ? !!isEnabled : false;
}
